/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { LoginContext } from '../../Contexts/LoginContext';
import { useSearchParams, Link } from 'react-router-dom';
import io from 'socket.io-client';
import axios from 'axios';
import { CgAttachment } from "react-icons/cg";
import { FaFileExcel, FaFilePowerpoint, FaUsersSlash } from "react-icons/fa";
import { IoIosChatboxes } from "react-icons/io";
import { TbInboxOff } from "react-icons/tb";
import { FaStar } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import { FaFilePdf, FaFileWord, FaFileAlt } from "react-icons/fa";
import Loader from '../../Components/utils/Loader';
import Dropdown from '../../Components/utils/Dropdown';
import { FiInfo } from "react-icons/fi";
import { showToast } from '../../Components/utils/ShowToast';
import SellerDefault from "../../images/pngs/seller.png"
import AdminDefault from "../../images/pngs/Logo.png"
import { Send, Package, ShoppingBag } from 'lucide-react';
import { formatCurrency, formatCurrencyDual, formatUsdToLocal, formatDate, formatDateTime, tommorrow, calculateSellerAmount, transformProduct, sellerFeePercentFor, orderSellerFeePercent } from '../../data/constants';
import PayoutFeeNote from '../../Components/utils/PayoutFeeNote';

let socket;

const renderTextWithLinks = (text) => {
  if (!text) return null;
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);
  return parts.map((part, idx) => (
    /^https?:\/\/[^\s]+$/.test(part)
      ? <a key={`link-${idx}`} href={part} target="_blank" rel="noopener noreferrer">{part}</a>
      : <React.Fragment key={`txt-${idx}`}>{part}</React.Fragment>
  ));
};

const QuoteModal = ({ isOpen, onClose, onSubmit, products, feesObj, currency, exchangeRate, isSeller, initialOffer, editingOfferId }) => {
  const isEditMode = Boolean(initialOffer && editingOfferId);
  const [quoteData, setQuoteData] = useState({
    selectedPosting: null,
    description: '',
    deliveryType: 'delivery',
    deliveryTime: { number: '', unit: 'Days' },
    price: '',
    quantity: '',
    deliveryFee: '',
    productImage: '',
    selectedPostingTitle: '',
    orderType: 'single',
    depositPercentage: '',
    remainingBalanceDueDate: '',
    refundPolicy: 'non_refundable',
    selectedAddedServices: [],
    buyerRequirements: [{ question: '', image: '' }],
  });
  const [errors, setErrors] = useState({});

  const productsToUse = (() => {
    if (!isEditMode || !initialOffer || !products?.length) return products || [];
    const prodId = initialOffer.productId?._id || initialOffer.productId;
    const exists = products.some(p => p.id === prodId || p.id?._id === prodId);
    if (exists) return products;
    return [{
      id: prodId,
      title: initialOffer.title,
      imageUrl: initialOffer.productImage,
      price: initialOffer.price,
      addedServices: initialOffer.addedServices || [],
      buyerQuestions: (initialOffer.buyerRequirements || []).map(q => ({ question: q.question })),
      listingType: 'product',
      serviceMode: '',
    }, ...products];
  })();

  useEffect(() => {
    if (isOpen && isEditMode && initialOffer && (productsToUse?.length || products?.length)) {
      const prodId = initialOffer.productId?._id || initialOffer.productId;
      let prod = (productsToUse || products).find(p => p.id === prodId || p.id?._id === prodId);
      if (!prod && initialOffer.title) {
        prod = {
          id: prodId,
          title: initialOffer.title,
          imageUrl: initialOffer.productImage,
          price: initialOffer.price,
          addedServices: initialOffer.addedServices || [],
          buyerQuestions: (initialOffer.buyerRequirements || []).map(q => ({ question: q.question })),
          listingType: 'product',
          serviceMode: '',
        };
      }
      const selectedOption = prod ? { value: prod.id, label: prod.title } : null;
      const reqs = (initialOffer.buyerRequirements || []).map(q => ({ question: q.question || '', image: q.image || '' }));
      const offerSvcNames = (initialOffer.addedServices || []).map(s => s.name);
      const selectedAddedServices = (prod?.addedServices || []).map((s, i) => offerSvcNames.includes(s.name) ? i : -1).filter(i => i >= 0);
      setQuoteData({
        selectedPosting: selectedOption,
        description: initialOffer.description || '',
        deliveryType: initialOffer.deliveryType || 'delivery',
        deliveryTime: {
          number: initialOffer.deliveryTime?.number || '',
          unit: initialOffer.deliveryTime?.unit || 'Days',
        },
        price: String(initialOffer.price ?? ''),
        quantity: initialOffer.quantity ?? 1,
        deliveryFee: String(initialOffer.deliveryFee ?? ''),
        productImage: initialOffer.productImage || '',
        selectedPostingTitle: initialOffer.title || '',
        orderType: initialOffer.orderType || 'single',
        depositPercentage: initialOffer.orderType === 'deposit' ? String(initialOffer.depositPercentage ?? '') : '',
        remainingBalanceDueDate: initialOffer.remainingBalanceDueDate ? new Date(initialOffer.remainingBalanceDueDate).toISOString().slice(0, 10) : '',
        refundPolicy: initialOffer.refundPolicy || 'non_refundable',
        selectedAddedServices,
        buyerRequirements: reqs.length ? reqs : [{ question: '', image: '' }],
      });
    } else if (isOpen && !isEditMode) {
      setQuoteData({
        selectedPosting: null,
        description: '',
        deliveryType: 'delivery',
        deliveryTime: { number: '', unit: 'Days' },
        price: '',
        quantity: '',
        deliveryFee: '',
        productImage: '',
        selectedPostingTitle: '',
        orderType: 'single',
        depositPercentage: '',
        remainingBalanceDueDate: '',
        refundPolicy: 'non_refundable',
        selectedAddedServices: [],
        buyerRequirements: [{ question: '', image: '' }],
      });
    }
  }, [isOpen, isEditMode, initialOffer, products, productsToUse]);

  const productOptions = (productsToUse || products || []).map(product => ({
    value: product.id,
    label: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={product.imageUrl}
          alt={product.title}
          style={{ width: '20px', height: '20px', marginRight: '8px', borderRadius: '4px' }}
        />
        {`${product.title} - USD ${product.price} (${product.listingType === 'service' ? 'Service' : 'Product'})`}
      </div>
    ),
  }));

  const orderTypeOptions = [
    { value: 'single', label: 'Single Payment' },
    { value: 'deposit', label: 'Deposit Based' },
  ];

  const deliveryTypeOptions = [
    { value: 'delivery', label: 'Delivery' },
    { value: 'pickup', label: 'Pickup' },
  ];

  const selectedProduct = quoteData.selectedPosting ? (productsToUse || products || []).find(p => p.id === quoteData.selectedPosting.value || p.id?._id === quoteData.selectedPosting.value) : null;
  const isSelectedService = selectedProduct?.listingType === 'service';
  const selectedServiceMode = selectedProduct?.serviceMode || '';

  const handleProductSelect = (selectedOption) => {
    const prod = products.find(p => p.id === selectedOption.value);
    if (prod) {
      const isService = prod.listingType === 'service';
      const svcMode = prod.serviceMode || '';
      setQuoteData({
        ...quoteData,
        selectedPosting: selectedOption,
        price: prod.price.toString(),
        productImage: prod.imageUrl,
        selectedPostingTitle: prod.title,
        selectedAddedServices: [],
        deliveryType: isService ? (svcMode === 'at_seller_location' ? 'pickup' : 'delivery') : quoteData.deliveryType,
        deliveryFee: isService ? '0' : quoteData.deliveryFee,
        buyerRequirements: prod.buyerQuestions?.length > 0
          ? prod.buyerQuestions.map(q => ({ question: q.question, image: q.image || '' }))
          : [{ question: '', image: '' }],
      });
      setErrors({ ...errors, selectedPosting: '' });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const isOnline = isSelectedService && selectedServiceMode === 'online';
    if (!quoteData.selectedPosting) newErrors.selectedPosting = 'Please select a product or service.';
    if (!quoteData.description.trim()) newErrors.description = 'Description is required.';
    if (!isOnline && (!quoteData.deliveryTime.number || !quoteData.deliveryTime.unit)) {
      newErrors.deliveryTime = `Please specify a valid ${isSelectedService ? 'service' : 'delivery/pickup'} time.`;
    }
    if (!quoteData.price || parseFloat(quoteData.price) <= 0) {
      newErrors.price = 'Please enter a valid price greater than 0.';
    }
    if (!quoteData.quantity || quoteData.quantity <= 0) {
      newErrors.quantity = 'Please enter a valid quantity greater than 0';
    }
    if (!isSelectedService && quoteData.deliveryType === 'delivery' && (!quoteData.deliveryFee || parseFloat(quoteData.deliveryFee) < 0)) {
      newErrors.deliveryFee = 'Please enter a valid fee greater than or equal to 0';
    }
    if (quoteData.orderType === 'deposit') {
      if (!quoteData.depositPercentage || quoteData.depositPercentage <= 0 || quoteData.depositPercentage >= 100) {
        newErrors.depositPercentage = 'Deposit percentage must be between 1 and 99.';
      }
      if (!quoteData.remainingBalanceDueDate) {
        newErrors.remainingBalanceDueDate = 'Remaining Balance Due Date is required.';
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dueDate = new Date(quoteData.remainingBalanceDueDate);
        if (dueDate < today) {
          newErrors.remainingBalanceDueDate = 'Remaining Balance Due Date must be today or later.';
        } else if (quoteData.deliveryTime.number && quoteData.deliveryTime.unit) {
          const timeInDays = quoteData.deliveryTime.unit === 'Days'
            ? parseInt(quoteData.deliveryTime.number)
            : quoteData.deliveryTime.unit === 'Months'
              ? parseInt(quoteData.deliveryTime.number) * 30
              : 0;
          const dueDatePlusOne = new Date(dueDate);
          dueDatePlusOne.setDate(dueDate.getDate() + 1);
          const minDeliveryDate = dueDatePlusOne;
          const assumedStartDate = new Date();
          const deliveryDate = new Date(assumedStartDate);
          deliveryDate.setDate(deliveryDate.getDate() + timeInDays);
          if (deliveryDate <= minDeliveryDate) {
            newErrors.deliveryTime = `The ${quoteData.deliveryType === 'delivery' ? 'delivery time' : 'pickup time'} must be at least one day after the Remaining Balance Due Date.`;
          }
        }
      }
    }
    if (quoteData.buyerRequirements.some((q) => !q.question?.trim())) {
      newErrors.buyerRequirements = 'All buyer questions must be filled or removed.';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(quoteData, isEditMode ? { isEdit: true, offerId: editingOfferId } : undefined);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modalOverlay quoteModalOverlay" onClick={onClose}>
      <div className="quoteModalContent" onClick={e => e.stopPropagation()}>
        <div className="quoteModalHeader">
          <div className="quoteModalTitleWrap">
            <Package className="quoteModalIcon" size={24} />
            <div>
              <h3 className="quoteModalTitle">{isEditMode ? 'Edit Offer' : 'Send Custom Offer'}</h3>
              <p className="quoteModalSubtitle">{isEditMode ? 'Update your offer details' : 'Create a personalized quote for your buyer'}</p>
            </div>
          </div>
          <button onClick={onClose} className="quoteModalClose" aria-label="Close">×</button>
        </div>
        <div className="quoteModalBody">
          <div className="quoteModalCard">
            <div className="quoteModalCardHeader">
              <span className="quoteModalCardIcon">📋</span>
              <div>
                <h4 className="quoteModalCardTitle">Offer Details</h4>
                <p className="quoteModalCardSubtitle">Select product and set pricing</p>
              </div>
            </div>
            <div className="quoteModalCardBody">
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">Select Product / Service <span className="quoteModalRequired">*</span></label>
                <Dropdown
                  options={productOptions}
                  value={quoteData.selectedPosting}
                  onChange={handleProductSelect}
                  placeholder="Choose a product or service"
                  disabled={isEditMode}
                />
                {errors.selectedPosting && <span className="quoteModalError">{errors.selectedPosting}</span>}
              </div>
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">Description <span className="quoteModalRequired">*</span></label>
                <textarea
                  value={quoteData.description}
                  onChange={(e) => setQuoteData({ ...quoteData, description: e.target.value })}
                  className="quoteModalInput quoteModalTextarea"
                  placeholder="Describe what's included in this offer"
                  rows={3}
                />
                {errors.description && <span className="quoteModalError">{errors.description}</span>}
              </div>
              <div className="quoteModalFormRow">
                <div className="quoteModalFormGroup">
                  <label className="quoteModalLabel">Price (USD) <span className="quoteModalRequired">*</span></label>
                  <input
                    type="number"
                    value={quoteData.price}
                    onChange={(e) => setQuoteData({ ...quoteData, price: e.target.value })}
                    className={`quoteModalInput ${errors.price ? 'quoteModalInputError' : ''}`}
                    placeholder="0.00"
                    min="0.01"
                    step="0.01"
                  />
                  {currency !== 'USD' && parseFloat(quoteData.price) > 0 && (
                    <span className="quoteModalLocalPreview">{formatUsdToLocal(quoteData.price, currency, exchangeRate)}</span>
                  )}
                  {errors.price && <span className="quoteModalError">{errors.price}</span>}
                </div>
                <div className="quoteModalFormGroup">
                  <label className="quoteModalLabel">Quantity <span className="quoteModalRequired">*</span></label>
                  <input
                    type="number"
                    value={quoteData.quantity}
                    onChange={(e) => setQuoteData({ ...quoteData, quantity: e.target.value })}
                    className={`quoteModalInput ${errors.quantity ? 'quoteModalInputError' : ''}`}
                    placeholder="1"
                    min="1"
                  />
                  {errors.quantity && <span className="quoteModalError">{errors.quantity}</span>}
                </div>
              </div>
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">Order Type</label>
                <Dropdown
                  options={orderTypeOptions}
                  value={orderTypeOptions.find(opt => opt.value === quoteData.orderType)}
                  onChange={(selected) => setQuoteData({ ...quoteData, orderType: selected.value, deliveryTime: { number: '', unit: 'Days' } })}
                  placeholder="Select order type"
                />
                <p className="quoteModalHelp">
                  <span>Single Payment: Full amount upfront.</span>
                  <span>Deposit Based: Partial payment to start, remainder by due date.</span>
                </p>
              </div>
          {quoteData.orderType === 'deposit' && (
            <>
              <div className="quoteModalFormRow">
                <div className="quoteModalFormGroup">
                  <label className="quoteModalLabel">Deposit % <span className="quoteModalRequired">*</span></label>
                  <input
                    type="number"
                    value={quoteData.depositPercentage}
                    onChange={(e) => setQuoteData({ ...quoteData, depositPercentage: e.target.value })}
                    placeholder="e.g. 50"
                    min="1"
                    max="99"
                    className={`quoteModalInput ${errors.depositPercentage ? 'quoteModalInputError' : ''}`}
                  />
                  {errors.depositPercentage && <span className="quoteModalError">{errors.depositPercentage}</span>}
                </div>
                <div className="quoteModalFormGroup">
                  <label className="quoteModalLabel">Balance Due Date <span className="quoteModalRequired">*</span></label>
                  <input
                    type="date"
                    value={quoteData.remainingBalanceDueDate}
                    onChange={(e) => setQuoteData({ ...quoteData, remainingBalanceDueDate: e.target.value })}
                    className={`quoteModalInput ${errors.remainingBalanceDueDate ? 'quoteModalInputError' : ''}`}
                    min={tommorrow}
                  />
                  {errors.remainingBalanceDueDate && <span className="quoteModalError">{errors.remainingBalanceDueDate}</span>}
                </div>
              </div>
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">Refund Policy</label>
                <Dropdown
                  options={[
                    { value: 'refundable', label: 'Refundable' },
                    { value: 'non_refundable', label: 'Non-refundable' },
                  ]}
                  value={{
                    value: quoteData.refundPolicy,
                    label: quoteData.refundPolicy === 'refundable' ? 'Refundable' : 'Non-refundable'
                  }}
                  onChange={(selected) => setQuoteData({ ...quoteData, refundPolicy: selected.value })}
                  placeholder="Select refund policy"
                />
              </div>
            </>
          )}
          {isSelectedService && (
            <div className="quoteModalInfoBanner">
              <FiInfo size={16} />
              <span>Service Mode: <strong>{selectedServiceMode === 'online' ? 'Online / Digital' : selectedServiceMode === 'onsite' ? 'At Buyer Location' : 'At Seller Location'}</strong>
                {selectedServiceMode === 'online' && ' — No delivery fee or time needed.'}</span>
            </div>
          )}
          {!isSelectedService && (
            <div className="quoteModalFormGroup">
              <label className="quoteModalLabel">Delivery Type</label>
              <Dropdown
                options={deliveryTypeOptions}
                value={deliveryTypeOptions.find(opt => opt.value === quoteData.deliveryType)}
                onChange={(selected) => setQuoteData({ ...quoteData, deliveryType: selected.value })}
                placeholder="Select delivery type"
              />
            </div>
          )}
          {!(isSelectedService && selectedServiceMode === 'online') && (
            <div className="quoteModalFormRow">
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">{isSelectedService ? 'Service Time' : (quoteData.deliveryType === 'delivery' ? 'Delivery Time' : 'Pickup Time')}</label>
                <div className="quoteModalTimeRow">
                  <input
                    type="number"
                    value={quoteData.deliveryTime.number}
                    onChange={(e) => setQuoteData({
                      ...quoteData,
                      deliveryTime: { ...quoteData.deliveryTime, number: e.target.value },
                    })}
                    placeholder="Number"
                    min="1"
                    className={`quoteModalInput quoteModalInputSmall ${errors.deliveryTime ? 'quoteModalInputError' : ''}`}
                  />
                  <select
                    value={quoteData.deliveryTime.unit}
                    onChange={(e) => setQuoteData({
                      ...quoteData,
                      deliveryTime: { ...quoteData.deliveryTime, unit: e.target.value },
                    })}
                    className={`quoteModalInput quoteModalInputSmall ${errors.deliveryTime ? 'quoteModalInputError' : ''}`}
                  >
                    {quoteData.orderType === 'single' ? (
                      <>
                        <option value="Minutes">Minutes</option>
                        <option value="Hours">Hours</option>
                        <option value="Days">Days</option>
                      </>
                    ) : (
                      <>
                        <option value="Days">Days</option>
                        <option value="Months">Months</option>
                      </>
                    )}
                  </select>
                </div>
                {errors.deliveryTime && <span className="quoteModalError">{errors.deliveryTime}</span>}
              </div>
              {!isSelectedService && quoteData.deliveryType === 'delivery' && (
                <div className="quoteModalFormGroup">
                  <label className="quoteModalLabel">Delivery Fee (USD)</label>
                  <input
                    type="number"
                    value={quoteData.deliveryFee}
                    onChange={(e) => setQuoteData({ ...quoteData, deliveryFee: e.target.value })}
                    className={`quoteModalInput ${errors.deliveryFee ? 'quoteModalInputError' : ''}`}
                    placeholder="0"
                    min="0"
                    step="0.01"
                  />
                  {currency !== 'USD' && parseFloat(quoteData.deliveryFee) > 0 && (
                    <span className="quoteModalLocalPreview">{formatUsdToLocal(quoteData.deliveryFee, currency, exchangeRate)}</span>
                  )}
                  {errors.deliveryFee && <span className="quoteModalError">{errors.deliveryFee}</span>}
                </div>
              )}
            </div>
          )}
          {quoteData.selectedPosting && (() => {
            const posting = products.find(p => p.id === quoteData.selectedPosting.value);
            if (!posting?.addedServices?.length) return null;
            return (
              <div className="quoteModalFormGroup">
                <label className="quoteModalLabel">Added Services</label>
                <div className="quoteModalCheckboxGroup">
                  {posting.addedServices.map((svc, idx) => (
                    <label key={`${svc.name}-${idx}`} className="quoteModalCheckboxItem">
                      <input
                        type="checkbox"
                        checked={quoteData.selectedAddedServices.includes(idx)}
                        onChange={(e) => {
                          const next = e.target.checked
                            ? [...quoteData.selectedAddedServices, idx]
                            : quoteData.selectedAddedServices.filter((i) => i !== idx);
                          setQuoteData({ ...quoteData, selectedAddedServices: next });
                        }}
                      />
                      <span>{svc.name} (+{formatCurrency(Number(svc.price) || 0, currency, exchangeRate)})</span>
                    </label>
                  ))}
                </div>
              </div>
            );
          })()}
          <div className="quoteModalFormGroup">
            <label className="quoteModalLabel">Buyer Questions <span className="quoteModalRequired">*</span></label>
            <p className="quoteModalHelp">Buyer must answer these before checkout</p>
            {quoteData.buyerRequirements.map((req, idx) => (
              <div key={`req-${idx}`} className="quoteModalReqRow">
                <input
                  type="text"
                  value={req.question}
                  onChange={(e) => {
                    const next = [...quoteData.buyerRequirements];
                    next[idx].question = e.target.value;
                    setQuoteData({ ...quoteData, buyerRequirements: next });
                  }}
                  className="quoteModalInput"
                  placeholder="Question (e.g. What text should be written?)"
                />
                <input
                  type="text"
                  value={req.image}
                  onChange={(e) => {
                    const next = [...quoteData.buyerRequirements];
                    next[idx].image = e.target.value;
                    setQuoteData({ ...quoteData, buyerRequirements: next });
                  }}
                  className="quoteModalInput quoteModalInputSmall"
                  placeholder="Image URL (optional)"
                />
                {quoteData.buyerRequirements.length > 1 && (
                  <button
                    type="button"
                    className="quoteModalRemoveBtn"
                    onClick={() => setQuoteData({ ...quoteData, buyerRequirements: quoteData.buyerRequirements.filter((_, i) => i !== idx) })}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              className="quoteModalAddBtn"
              onClick={() => setQuoteData({ ...quoteData, buyerRequirements: [...quoteData.buyerRequirements, { question: '', image: '' }] })}
            >
              + Add Question
            </button>
            {errors.buyerRequirements && <span className="quoteModalError">{errors.buyerRequirements}</span>}
          </div>
          {isSeller && feesObj?.seller != null && (() => {
            // The rate follows the listing this quote is written against, not a
            // single site-wide percentage.
            const feePercent = sellerFeePercentFor(feesObj?.sellerMatrix, {
              listingType: selectedProduct?.listingType,
            });
            const price = parseFloat(quoteData.price) || 0;
            const qty = parseInt(quoteData.quantity, 10) || 0;
            const deliveryFee = quoteData.deliveryType === 'delivery' ? (parseFloat(quoteData.deliveryFee) || 0) : 0;
            const gross = price * qty + deliveryFee;
            const sellerAmount = gross > 0 ? calculateSellerAmount(gross, feePercent) : 0;

            return (
              <div className="quoteModalSellerPreview">
                <strong>You will receive:</strong>{' '}
                {formatCurrencyDual(sellerAmount, currency, exchangeRate)}
                <span className="quoteModalSellerPreviewNote">(after {feePercent}% service fee)</span>
                <PayoutFeeNote />
              </div>
            );
          })()}
            </div>
          </div>
        </div>
        <div className="quoteModalFooter">
          <button type="button" onClick={onClose} className="quoteModalBtn quoteModalBtnSecondary">Cancel</button>
          <button type="button" onClick={handleSubmit} className="quoteModalBtn quoteModalBtnPrimary">{isEditMode ? 'Update Offer' : 'Send Quote'}</button>
        </div>
      </div>
    </div>
  );
};

const ChatPage = () => {
  const { user, admin, refreshChatUnreadCount, currency, exchangeRate, feesObj } = useContext(LoginContext);
  const [chats, setChats] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [selectedChat, setSelectedChat] = useState(null);
  const [isParticipantAdmin, setIsParticipantAdmin] = useState(false);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [searchParams] = useSearchParams();
  const messagesEndRef = useRef(null);
  const [file, setFile] = useState(null);
  const [showImageModel, setShowImageModel] = useState(null);
  const [showQuoteModel, setShowQuoteModel] = useState(false);
  const [quoteItems, setQuoteItems] = useState([]);
  const [editingOffer, setEditingOffer] = useState(null);
  const [editingOfferId, setEditingOfferId] = useState(null);
  const [sendLoading, setSendLoading] = useState(false);
  const token = localStorage.getItem('token');
  const adminToken = localStorage.getItem('adminToken');
  const [isMessagesLoading, setIsMessagesLoading] = useState(false);
  const [isChatsLoading, setIsChatsLoading] = useState(true);
  const [isCheckmateLoading, setIsCheckmateLoading] = useState(false);
  const [chatWarnings, setChatWarnings] = useState([]);
  const [activeWarning, setActiveWarning] = useState(null);
  const [activeOrders, setActiveOrders] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [sellerProducts, setSellerProducts] = useState([]);
  const [isOtherInfoLoading, setIsOtherInfoLoading] = useState(false);

  useEffect(() => {
    const msg = localStorage.getItem('message');
    if (msg) {
      showToast(msg, "success");
      localStorage.removeItem('message');
    }
  }, []);

  useEffect(() => {
    const fetchChatWarnings = async () => {
      try {
        const authToken = token || adminToken;
        if (!authToken) return;
        const res = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/restrictions`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        if (res.data.success && res.data.restriction?.chatWarnings) {
          setChatWarnings(res.data.restriction.chatWarnings);
        }
      } catch { }
    };
    fetchChatWarnings();
  }, [token, adminToken]);

  const checkChatWarnings = (text) => {
    if (!text || chatWarnings.length === 0) return null;
    const lowerText = text.toLowerCase();
    for (const warning of chatWarnings) {
      for (const word of warning.words) {
        if (lowerText.includes(word.toLowerCase())) {
          return warning;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    // The server derives the identity from this token; it no longer accepts a
    // client-declared userId.
    const authToken = token || adminToken;
    if (!authToken) return;

    socket = io(`${process.env.REACT_APP_Backend_Host_Name}`, {
      auth: { token: authToken }
    });
  }, [token, adminToken]);

  useEffect(() => {
    const paramsId = searchParams.get("p");
    if (paramsId) {
      axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/auth/getUser/${paramsId}`)
        .then(response => {
          if (response.data.success) {
            setSelectedParticipant(response.data.user);
          }
        });
    }
  }, [searchParams]);

  useEffect(() => {
    if (!user && !admin) return;

    axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/${user ? "userChats" : "adminChats"}/${user ? user._id : admin._id}`, { headers: { Authorization: `Bearer ${user ? token : adminToken}` } })
      .then(response => {
        if (response.data.success) {
          const chatsFetched = response.data?.chats;
          if (selectedParticipant) {
            const dbChats = chatsFetched.find(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant?._id);
            const localChats = chats.find(c => (c.participantId?._id || c.participantId?._id) === selectedParticipant?._id);
            if (!dbChats && !localChats)
              setChats([{ adminParticipantId: isParticipantAdmin ? selectedParticipant : null, participantId: isParticipantAdmin ? null : selectedParticipant, messages: [] }, ...chatsFetched]);
          }
          else
            setChats(chatsFetched);
          setIsChatsLoading(false);
        }
      });
  }, [user, admin]);

  useEffect(() => {
    socket.on('receiveMessage', (newMessage) => {
      if (selectedParticipant && selectedParticipant._id === newMessage.senderId) {
        setMessages(prevMessages => [...prevMessages, newMessage]);
        const id = user ? user._id : admin._id;
        const hdr = { Authorization: `Bearer ${user ? token : adminToken}` };
        if (newMessage.chatId) {
          axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/markChatAsRead`, { chatId: newMessage.chatId, userId: id }, { headers: hdr }).catch(() => { });
        }
      }
    });

    socket.on('offerStatusChanged', ({ offerId, status, receiverId }) => {
      const myId = user?._id || admin?._id;
      if (selectedParticipant && myId === receiverId) {
        setMessages(prev => prev.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, status } } : m));
        setChats(prev => prev.map(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant._id
          ? { ...c, messages: c.messages.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, status } } : m) }
          : c));
      }
    });

    socket.on('offerUpdated', ({ offerId, updatedOffer, receiverId }) => {
      const myId = user?._id || admin?._id;
      if (selectedParticipant && myId === receiverId) {
        setMessages(prev => prev.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, ...updatedOffer } } : m));
        setChats(prev => prev.map(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant._id
          ? { ...c, messages: c.messages.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, ...updatedOffer } } : m) }
          : c));
        showToast('Offer was updated by seller', 'info');
      }
    });

    return () => {
      socket.off('receiveMessage');
      socket.off('offerStatusChanged');
      socket.off('offerUpdated');
    };
  }, [selectedParticipant, user, admin, token, adminToken]);

  useEffect(() => {
    if (!user && !admin) return;
    if (chats && chats.length > 0) {
      const id = user ? user._id : admin._id;
      const hdr = { Authorization: `Bearer ${user ? token : adminToken}` };
      const chatIds = chats.map(c => c._id);
      axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/markMultipleChatsAsRead`, { chatIds, userId: id }, { headers: hdr })
        .then(() => refreshChatUnreadCount())
        .catch(() => { });
    }
  }, [chats, user, admin]);

  useEffect(() => {
    if (!user && !admin) return;
    if (selectedParticipant) {
      axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/${user ? "userChats" : "adminChats"}/${user ? user._id : admin._id}`, { headers: { Authorization: `Bearer ${user ? token : adminToken}` } })
        .then(response => {
          if (response.data.success) {
            const updatedChats = response.data.chats;
            const dbChats = updatedChats.find(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant?._id);
            const localChats = updatedChats.find(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant?._id);
            if (!dbChats && !localChats) {
              setChats([{ adminParticipantId: isParticipantAdmin ? selectedParticipant : null, participantId: isParticipantAdmin ? null : selectedParticipant, messages: [] }, ...chats, ...updatedChats]);
              setMessages([]);
            } else {
              setChats(updatedChats);
              setMessages(dbChats.messages);
            }
          }
        })
        .catch(e => {
        }).finally(() => {
          setIsMessagesLoading(false);
          setIsChatsLoading(false);
        });
    }
  }, [user, selectedParticipant]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    if (!selectedParticipant && chats.length > 0) {
      selectChat(chats[0], true);
    }
  }, [chats, selectedParticipant]);

  useEffect(() => {
    if (!selectedChat) return;
    const cid = selectedChat._id;
    if (!cid) return;
    const id = user ? user._id : admin._id;
    const hdr = user
      ? { Authorization: `Bearer ${token}` }
      : { Authorization: `Bearer ${adminToken}` };
    axios
      .post(
        `${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/markChatAsRead`,
        { chatId: cid, userId: id },
        { headers: hdr }
      )      .then(() => refreshChatUnreadCount())
      .catch(() => { });
  }, [selectedChat]);

  useEffect(() => {
    if (!selectedParticipant || isParticipantAdmin || !user) {
      setActiveOrders([]);
      setOrderHistory([]);
      setSellerProducts([]);
      return;
    }
    const ACTIVE_STATUSES = ['Order Placed', 'In Progress', 'Out for Delivery', 'Delivered', 'Preparing Order', 'Ready for Pickup', 'Picked Up'];
    const COMPLETED_STATUSES = ['Completed', 'Cancelled', 'Resolved', 'OnHold', 'InDispute'];

    const fetchOtherInfo = async () => {
      setIsOtherInfoLoading(true);
      setActiveOrders([]);
      setOrderHistory([]);
      setSellerProducts([]);
      try {
        const hdr = { Authorization: `Bearer ${token}` };

        if (user.role === 'buyer' && selectedParticipant.role === 'seller') {
          const [ordersRes, productsRes] = await Promise.all([
            axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/orders/buyer/current`, { headers: hdr }),
            axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/seller/${selectedParticipant.sellerId?._id}`, { headers: hdr }),
          ]);
          const allOrders = ordersRes.data?.orders || [];
          const sellerId = selectedParticipant.sellerId?._id?.toString?.() || selectedParticipant.sellerId?.toString?.();
          const related = allOrders.filter(o => (o.sellerId?._id || o.sellerId)?.toString?.() === sellerId);
          setActiveOrders(related.filter(o => ACTIVE_STATUSES.includes(o.timelineStatus)));
          setOrderHistory(related.filter(o => COMPLETED_STATUSES.includes(o.timelineStatus)));
          if (productsRes.data?.success && productsRes.data.products?.length) {
            setSellerProducts((productsRes.data.products || []).map(transformProduct));
          }
        } else if (user.role === 'seller' && selectedParticipant.role === 'buyer') {
          const ordersRes = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/orders/seller/current`, { headers: hdr });
          const allOrders = ordersRes.data?.orders || [];
          const buyerId = selectedParticipant._id?.toString?.();
          const related = allOrders.filter(o => (o.buyerId?._id || o.buyerId)?.toString?.() === buyerId);
          setActiveOrders(related.filter(o => ACTIVE_STATUSES.includes(o.timelineStatus)));
          setOrderHistory(related.filter(o => COMPLETED_STATUSES.includes(o.timelineStatus)));
        } else if (selectedParticipant.role === 'seller') {
          const productsRes = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/seller/${selectedParticipant.sellerId?._id}`, { headers: hdr });
          if (productsRes.data?.success && productsRes.data.products?.length) {
            setSellerProducts((productsRes.data.products || []).map(transformProduct));
          }
        }
      } catch (err) {
        console.error('Failed to fetch chat other info:', err);
      } finally {
        setIsOtherInfoLoading(false);
      }
    };
    fetchOtherInfo();
  }, [selectedParticipant, user, isParticipantAdmin, token]);

  const sendMessage = async () => {
    if (!message.trim() && !file) return;

    setSendLoading(true);

    const formData = new FormData();
    formData.append('senderId', user ? user?._id : admin?._id);
    formData.append('receiverId', selectedParticipant._id);
    formData.append('receiverEmail', selectedParticipant?.email);
    formData.append('text', message);
    formData.append('isParticipantAdmin', isParticipantAdmin);
    if (file)
      formData.append('file', file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/sendMessage/${user ? "user" : "admin"}`, formData, {
        headers: {
          Authorization: `Admin ${user ? token : adminToken}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        setMessages(prevMessages => [...prevMessages, response.data.message]);
        setChats(prevChats => {
          const updatedChats = prevChats.map(chat => {
            if ((chat.participantId?._id || chat.adminParticipantId?._id) === selectedParticipant._id) {
              return { ...chat, messages: [...chat.messages, response.data.message] };
            }
            return chat;
          });
          return updatedChats;
        });
        setMessage("");
        setFile(null);
        socket.emit('sendMessage', response.data.message);
      }
      setSendLoading(false);
    } catch (error) {
      setSendLoading(false);
      showToast(error?.response?.data?.error || "Failed to send message!", "error");
    }
    setSendLoading(false);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const removeFile = () => {
    if (!sendLoading)
      setFile(null);
  };

  const selectChat = (chat, initial) => {
    if ((!initial && isMessagesLoading) || sendLoading)
      return;

    if (!initial && (chat?.participantId?._id === selectedParticipant?._id || chat?.adminParticipantId?._id === selectedParticipant?._id))
      return;

    setIsMessagesLoading(true);
    setSelectedChat(chat);
    setSelectedParticipant(chat.participantId || chat.adminParticipantId);
    if (chat.adminParticipantId && chat.isParticipantAdmin)
      setIsParticipantAdmin(true);
    else
      setIsParticipantAdmin(false);
  };

  const renderDocumentIcon = (fileType) => {
    if (fileType === 'application/pdf') return <FaFilePdf size={18} />;
    if (fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return <FaFileWord size={18} />;
    if (fileType === 'application/vnd.ms-excel' || fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return <FaFileExcel size={18} />;
    if (fileType === 'application/vnd.ms-powerpoint' || fileType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') return <FaFilePowerpoint size={18} />;
    return <FaFileAlt size={18} />;
  };

  const handleOpenQuoteModel = () => {
    setEditingOffer(null);
    setEditingOfferId(null);
    setShowQuoteModel(true);
    axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/seller/product`, { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        if (response.data.success) {
          const products = response.data.products.map(product => ({
            id: product._id,
            title: product.title,
            imageUrl: product.thumbnail,
            price: product.pricingType === 'fixed' ? product.packages[0]?.options.basePrice || 0 : product.variablePricing?.basePrice || 0,
            addedServices: product.addedServices || [],
            buyerQuestions: product.buyerQuestions || [],
            listingType: product.listingType || 'product',
            serviceMode: product.serviceMode || '',
          }));
          setQuoteItems(products);
        }
      })
      .catch(e => {
        showToast(e?.response?.data?.error || "Failed to fetch products!", "error");
      });
  };

  const handleEditOffer = (msg) => {
    if (!msg?.offer || msg.offer.status !== 'Active' || msg.senderId !== user?._id) return;
    setEditingOffer(msg.offer);
    setEditingOfferId(msg.offer.offerId);
    axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/products/seller/product`, { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        if (response.data.success) {
          const products = response.data.products.map(product => ({
            id: product._id,
            title: product.title,
            imageUrl: product.thumbnail,
            price: product.pricingType === 'fixed' ? product.packages[0]?.options.basePrice || 0 : product.variablePricing?.basePrice || 0,
            addedServices: product.addedServices || [],
            buyerQuestions: product.buyerQuestions || [],
            listingType: product.listingType || 'product',
            serviceMode: product.serviceMode || '',
          }));
          setQuoteItems(products);
        }
      })
      .catch(e => {
        showToast(e?.response?.data?.error || "Failed to fetch products!", "error");
      });
    setTimeout(() => setShowQuoteModel(true), 0);
  };

  const handleSendOffer = (quoteData, editOpts) => {
    const isEdit = editOpts?.isEdit && editOpts?.offerId;

    setIsCheckmateLoading(true);

    const selectedProduct = quoteItems.find((p) => p.id === quoteData.selectedPosting?.value || p.id?._id === quoteData.selectedPosting?.value);
    const offerAddedServices = (quoteData.selectedAddedServices || [])
      .map((idx) => selectedProduct?.addedServices?.[idx])
      .filter(Boolean)
      .map((svc) => ({
        name: svc.name,
        description: svc.description || '',
        price: Number(svc.price) || 0,
        image: svc.image || '',
      }));

    const isOnlineOffer = selectedProduct?.listingType === 'service' && selectedProduct?.serviceMode === 'online';
    const offer = {
      productId: quoteData.selectedPosting?.value,
      title: quoteData.selectedPostingTitle,
      productImage: quoteData.productImage,
      description: quoteData.description,
      deliveryType: quoteData.deliveryType,
      deliveryTime: isOnlineOffer ? { number: 1, unit: 'Days' } : quoteData.deliveryTime,
      price: parseFloat(quoteData.price),
      quantity: quoteData.quantity,
      deliveryFee: isOnlineOffer ? 0 : parseFloat(quoteData.deliveryFee) || 0,
      orderType: quoteData.orderType,
      depositPercentage: quoteData.orderType === 'deposit' ? parseFloat(quoteData.depositPercentage) : undefined,
      remainingBalanceDueDate: quoteData.orderType === 'deposit' ? quoteData.remainingBalanceDueDate : undefined,
      refundPolicy: quoteData.orderType === 'deposit' ? quoteData.refundPolicy : undefined,
      addedServices: offerAddedServices,
      buyerRequirements: (quoteData.buyerRequirements || [])
        .filter((q) => q.question?.trim())
        .map((q) => ({ question: q.question.trim(), image: q.image || '' })),
      listingType: selectedProduct?.listingType || 'product',
      serviceMode: selectedProduct?.serviceMode || '',
    };

    if (isEdit) {
      axios.put(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/offer/update`, {
        offerId: editOpts.offerId,
        senderId: user._id,
        receiverId: selectedParticipant._id,
        offer: JSON.stringify(offer),
      }, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          if (response.data.success) {
            setMessages(prev => prev.map(m => {
              if (m.offer?.offerId === editOpts.offerId) {
                return { ...m, offer: { ...m.offer, ...response.data.offer } };
              }
              return m;
            }));
            setChats(prev => prev.map(c => {
              if ((c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant._id) {
                return { ...c, messages: c.messages.map(m => m.offer?.offerId === editOpts.offerId ? { ...m, offer: { ...m.offer, ...response.data.offer } } : m) };
              }
              return c;
            }));
            setShowQuoteModel(false);
            setEditingOffer(null);
            setEditingOfferId(null);
            showToast('Offer updated successfully', 'success');
          }
        })
        .catch(error => showToast(error?.response?.data?.error || 'Failed to update offer!', 'error'))
        .finally(() => setIsCheckmateLoading(false));
      return;
    }

    const formData = new FormData();
    formData.append('senderId', user._id);
    formData.append('receiverId', selectedParticipant._id);
    formData.append('receiverEmail', selectedParticipant?.email);
    formData.append('offer', JSON.stringify(offer));
    formData.append('isParticipantAdmin', isParticipantAdmin);

    axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/sendMessage/user`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        if (response.data.success) {
          setMessages([...messages, response.data.message]);
          setShowQuoteModel(false);
        }
      })
      .catch(error => {
        showToast(error?.response?.data?.error || "Failed to send offer!", "error");
      }).finally(() => setIsCheckmateLoading(false));
  };

  const handleOfferActions = async (e, action, offerId) => {
    e.preventDefault();
    if (!window.confirm(`Are you sure you want to ${action} this offer?`))
      return;

    try {
      const response = await axios.post(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/offer/action`, {
        action,
        offerId,
        senderId: (user || admin)?._id,
        receiverId: selectedParticipant._id
      }, {
        headers: { Authorization: `Bearer ${user ? token : adminToken}` }
      });

      if (response.data.success) {
        const newStatus = action === 'Withdraw' ? 'Withdrawn' : action === 'Reject' ? 'Rejected' : 'Accepted';
        setMessages(prev => prev.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, status: newStatus } } : m));
        setChats(prev => prev.map(c => (c.participantId?._id || c.adminParticipantId?._id) === selectedParticipant._id
          ? { ...c, messages: c.messages.map(m => m.offer?.offerId === offerId ? { ...m, offer: { ...m.offer, status: newStatus } } : m) }
          : c));
        showToast(`Offer ${action === 'Withdraw' ? 'withdrawn' : action === 'Reject' ? 'rejected' : 'accepted'} successfully`, 'success');
      }
    } catch (error) {
      showToast(error?.response?.data?.error || "Something went wrong!", "error");
    }
  };

  const handleFileDownload = async (fileUrl, originalFileName) => {
    try {

      const response = await axios({
        url: `${process.env.REACT_APP_Backend_Host_Name}/api/v1/chats/download`,
        method: 'GET',
        params: {
          fileUrl,
          originalFileName
        },
        responseType: 'blob',
        withCredentials: true
      });

      const contentDisposition = response.headers['content-disposition'];
      const downloadFileName = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : originalFileName;

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
      const downloadLink = document.createElement('a');
      downloadLink.href = blobUrl;
      downloadLink.download = downloadFileName;

      document.body.appendChild(downloadLink);
      downloadLink.click();

      setTimeout(() => {
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error('Download failed:', error);
      showToast("Failed to download file!", "error");
    }
  };

  if (!user && !admin) return <Loader type="simple" />

  return (
    <div className="chatDiv commonChatDiv">
      <section className={!admin && "section"}>
        <div className="chatContent">
          <div className="chatsList">
            <div className="header">Inbox ({chats.length < 10 ? "0" + chats.length : chats.length})</div>
            <div className="chatBoxes content">
              {isChatsLoading ? <Loader type="simple" /> : chats.length > 0 ? chats.map(chat => (
                <div
                  key={chat.participantId?._id || chat.adminParticipantId?._id}
                  className={`chatBox ${(selectedParticipant && (chat.participantId?._id === selectedParticipant?._id || chat.adminParticipantId?._id === selectedParticipant?._id)) ? "active" : ""}`}
                  onClick={() => selectChat(chat)}
                >
                  <div className="imgDiv">
                    <img src={chat.participantId?.role === "seller" ? `${chat?.participantId.sellerId?.profileImage}` : chat.adminParticipantId ? AdminDefault : SellerDefault} alt="Profile" />
                  </div>
                  <div className='chatBoxContent'>
                    <div className='fw600'>{chat.participantId?._id === user?._id ? "You - Personal Chat" : chat.participantId ? chat.participantId?.username : "Admin"}</div>
                    <p className='lastMessage singleLineSmallText'>
                      {messages.length > 0 && chat.messages[chat.messages.length - 1]?.offer ? "Custom Offer" : chat.messages[chat.messages.length - 1]?.text !== "" ? chat.messages[chat.messages.length - 1]?.text : "File"}
                    </p>
                  </div>
                </div>
              )) : (
                <div className='nothingFound'>
                  <TbInboxOff className='icon' />
                  <div>No Conversation yet!</div>
                </div>
              )}
            </div>
          </div>

          <div className="chatRoom">
            {isMessagesLoading ? <Loader type="simpleMax" /> : selectedParticipant ? (
              <>
                <div className="header">
                  <div className="headerLeft">
                    <img src={selectedParticipant?.role === "seller" ? `${selectedParticipant?.sellerId?.profileImage}` : isParticipantAdmin ? AdminDefault : SellerDefault} alt="Profile" />
                    <Link to={!isParticipantAdmin && selectedParticipant?.role === "seller" && `/vendorDetail/${selectedParticipant?.sellerId?._id}`} >{selectedParticipant?._id === user?._id ? "You - Personal Chat" : isParticipantAdmin ? "Admin" : selectedParticipant?.username}</Link>
                  </div>
                  {user && user?.role === "seller" && !isParticipantAdmin && selectedParticipant?._id !== user?._id && (
                    <button className='headerActionButton' disabled={sendLoading} onClick={handleOpenQuoteModel}>
                      <Package size={16} />
                      <span>Send Quote</span>
                    </button>
                  )}
                </div>
                <div className="messages content">
                  {messages.map((msg, index) => (
                    msg.isOrderUpdate ? (
                      <div key={index} className="chatOrderUpdateBanner">
                        <div className="chatOrderUpdateInner">
                          <FiInfo className="chatOrderUpdateIcon" />
                          <span className="chatOrderUpdateText">{msg.text}</span>
                          {msg.orderLink && (() => {
                            const orderIdFromLink = msg.orderLink.split('/').filter(Boolean).pop();
                            const viewOrderTo = orderIdFromLink
                              ? (user?.role === 'seller' ? `/sellerOrderDetailPage/${orderIdFromLink}` : `/orderDetailPage/${orderIdFromLink}`)
                              : msg.orderLink;
                            return <Link to={viewOrderTo} className="chatOrderUpdateLink">View Order</Link>;
                          })()}
                        </div>
                        <span className="chatOrderUpdateTime">{formatDateTime(msg.timestamp)}</span>
                      </div>
                    ) : (
                    <div key={index} className={msg.senderId === (user ? user?._id : admin?._id) ? "message sent" : "message received"}>
                      <div className='senderName fw600 lightBlackPrimary fs09'>
                        {msg.senderId !== (user ? user?._id : admin?._id) && <div>{isParticipantAdmin ? "Admin" : selectedParticipant.username}</div>}
                        <span className='messageTime'>{formatDateTime(msg.timestamp)}</span>
                      </div>
                      <div>{msg.offer ? "Custom Offer" : renderTextWithLinks(msg.text)}</div>
                      {msg.fileUrl && (
                        <div className="fileBox">
                          {msg.fileType.startsWith('image/') && (
                            <img src={`${msg.fileUrl}`} alt="Attachment" style={{ maxWidth: '100px', maxHeight: '100px', cursor: "pointer" }} onClick={() => setShowImageModel(msg.fileUrl)} />
                          )}
                          {msg.fileType.startsWith('video/') && (
                            <video controls style={{ maxWidth: '100%', maxHeight: '400px' }}>
                              <source src={`${msg.fileUrl}`} type={msg.fileType} />
                              Your browser does not support the video tag.
                            </video>
                          )}
                          {(msg.fileType.startsWith('application/') || msg.fileType.startsWith('text/')) && (
                            <div className="documentBox" onClick={() => handleFileDownload(msg.fileUrl, msg.originalFileName)}>
                              {renderDocumentIcon(msg.fileType)}
                              <p>{msg.originalFileName}</p>
                            </div>
                          )}
                        </div>
                      )}
                      {msg.offer && (
                        <div className="chatOfferCard">
                          <div className="chatOfferHeader">
                            <img src={msg.offer.productImage} alt={msg.offer.title} className="chatOfferImage" />
                            <div className="chatOfferHeaderInfo">
                              <span className={`chatOfferTypeBadge ${msg.offer.listingType === 'service' ? 'chatOfferTypeService' : 'chatOfferTypeProduct'}`}>
                                {msg.offer.listingType === 'service' ? 'Service' : 'Product'}
                              </span>
                              <h4 className="chatOfferTitle">{msg.offer.title}</h4>
                              <p className="chatOfferTotal">{formatCurrencyDual(
                                (msg.offer.price * msg.offer.quantity) + (msg.offer.deliveryFee || 0) + ((msg.offer.addedServices || []).reduce((s, a) => s + (Number(a.price) || 0), 0)),
                                currency, exchangeRate
                              )} total</p>
                            </div>
                          </div>
                          {msg.offer.description && (
                            <div className="chatOfferDescription">{msg.offer.description}</div>
                          )}
                          <div className="chatOfferDetails">
                            <div className="chatOfferDetailRow">
                              <span className="chatOfferDetailLabel">Order Type</span>
                              <span>{msg.offer.orderType === "deposit" ? "Deposit Based" : "Single Payment"}</span>
                            </div>
                            {msg.offer.listingType === 'service' ? (
                              <>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Service Mode</span>
                                  <span>{msg.offer.serviceMode === 'online' ? 'Online / Digital' : msg.offer.serviceMode === 'onsite' ? 'At Your Location' : msg.offer.serviceMode === 'at_seller_location' ? 'At Seller Location' : '—'}</span>
                                </div>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Turnaround</span>
                                  <span>{msg.offer.deliveryTime?.number} {msg.offer.deliveryTime?.unit}</span>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Delivery</span>
                                  <span>{msg.offer.deliveryType?.charAt(0).toUpperCase() + msg.offer.deliveryType?.slice(1).toLowerCase()}</span>
                                </div>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">{msg.offer.deliveryType === 'delivery' ? "Delivery Time" : "Pickup Time"}</span>
                                  <span>{msg.offer.deliveryTime?.number} {msg.offer.deliveryTime?.unit}</span>
                                </div>
                                {msg.offer.deliveryType === 'delivery' && (
                                  <div className="chatOfferDetailRow">
                                    <span className="chatOfferDetailLabel">Delivery Fee</span>
                                    <span>{msg.offer.deliveryFee > 0 ? formatCurrencyDual(msg.offer.deliveryFee, currency, exchangeRate) : 'Free'}</span>
                                  </div>
                                )}
                              </>
                            )}
                            <div className="chatOfferDetailRow">
                              <span className="chatOfferDetailLabel">Quantity</span>
                              <span>{msg.offer.quantity} × {formatCurrencyDual(msg.offer.price, currency, exchangeRate)}</span>
                            </div>
                            {msg.offer.addedServices?.length > 0 && (
                              <div className="chatOfferDetailRow chatOfferDetailCol">
                                <span className="chatOfferDetailLabel">Added Services</span>
                                <ul className="chatOfferServiceList">
                                  {msg.offer.addedServices.map((s, i) => (
                                    <li key={i}>{s.name} (+{formatCurrencyDual(Number(s.price) || 0, currency, exchangeRate)})</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {msg.offer.buyerRequirements?.length > 0 && (
                              <div className="chatOfferDetailRow">
                                <span className="chatOfferDetailLabel">Buyer Questions</span>
                                <span>{msg.offer.buyerRequirements.length} question(s) to answer</span>
                              </div>
                            )}
                            {msg.offer.orderType === 'deposit' && (
                              <>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Initial Deposit</span>
                                  <span>{msg.offer.depositPercentage}%</span>
                                </div>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Balance Due</span>
                                  <span>{formatDate(msg.offer.remainingBalanceDueDate) || new Date(msg.offer.remainingBalanceDueDate).toLocaleDateString()}</span>
                                </div>
                                <div className="chatOfferDetailRow">
                                  <span className="chatOfferDetailLabel">Refund Policy</span>
                                  <span>{msg.offer.refundPolicy === 'refundable' ? 'Refundable' : 'Non-refundable'}</span>
                                </div>
                              </>
                            )}
                          </div>
                          {msg.offer.offerEditedAt && msg.senderId !== (user ? user?._id : admin?._id) && (
                            <div className="chatOfferUpdatedBadge">Offer updated by seller</div>
                          )}
                          <div className={`chatOfferStatus chatOfferStatus${msg.offer.status === "Accepted" ? "Accepted" : msg.offer.status === "Rejected" ? "Rejected" : msg.offer.status === "Withdrawn" ? "Withdrawn" : "Active"}`}>
                            {msg.offer.status === "Accepted" ? "Offer Accepted" :
                              msg.offer.status === "Rejected" ? "Offer Rejected" :
                                msg.offer.status === "Withdrawn" ? "Offer Withdrawn" :
                                  msg.senderId !== (user ? user?._id : admin?._id) ? (
                                    <div className="chatOfferActions">
                                      <button type="button" className="chatOfferBtn chatOfferBtnReject" onClick={(e) => handleOfferActions(e, "Reject", msg.offer.offerId)}>Reject</button>
                                      <Link to={`/checkoutPage?c=${msg._id}`} className="chatOfferBtn chatOfferBtnAccept">Place Order</Link>
                                    </div>
                                  ) : (
                                    <div className="chatOfferActions">
                                      <button type="button" className="chatOfferBtn chatOfferBtnEdit" onClick={() => handleEditOffer(msg)}>Edit</button>
                                      <button type="button" className="chatOfferBtn chatOfferBtnWithdraw" onClick={(e) => handleOfferActions(e, "Withdraw", msg.offer.offerId)}>Withdraw Offer</button>
                                    </div>
                                  )}
                          </div>
                        </div>
                      )}
                    </div>
                    )
                  ))}
                  <div ref={messagesEndRef} />
                </div>

                <div className="writeMessageDiv">

                  {file && (
                    <div className="filePreview">
                      <p>{file.name}</p>
                      <IoIosCloseCircle className='removeFileIcon' onClick={removeFile} />
                    </div>
                  )}
                  {activeWarning && (
                    <div className="chatWarningBanner">
                      <FiInfo className="chatWarningIcon" />
                      <span>{activeWarning.message}</span>
                      <button className="chatWarningClose" onClick={() => setActiveWarning(null)}>&times;</button>
                    </div>
                  )}
                  <div className="writeMessageContent">
                    <input
                      type="text"
                      value={message}
                      onChange={(e) => {
                        setMessage(e.target.value);
                        const warning = checkChatWarnings(e.target.value);
                        setActiveWarning(warning);
                      }}
                      placeholder='Type a Message'
                      className='messageInput'
                      disabled={sendLoading}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          sendMessage();
                        }
                      }}
                    />
                    <div className="right">
                      <div>
                        <label htmlFor='fileInput' className='sendButton'><CgAttachment size={20} /></label>
                        <input
                          type="file"
                          className="hidden"
                          id="fileInput"
                          onChange={handleFileChange}
                          disabled={sendLoading}
                        />
                      </div>
                      <button className="sendButton" onClick={sendMessage} disabled={sendLoading}><Send size={20} /></button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className='nothingFound'>
                <IoIosChatboxes className='icon' />
                <div>Select a Conversation to start Chat</div>
              </div>
            )}
          </div>

          <div className="otherInfo">
            {selectedParticipant ? (
              <>
                <div className="header">
                  <div>Other Info</div>
                </div>
                <div className="participantDetails content">
                  {!isParticipantAdmin && <><h2 className="secondaryHeading">
                    About <Link to={selectedParticipant?.role === "seller" && `/vendorDetail/${selectedParticipant?.sellerId?._id}`}>@{selectedParticipant.username}</Link>
                  </h2>
                    {selectedParticipant.role === "seller" && <><div className="row"><p>Name</p><div className='fw600'>{selectedParticipant.sellerId.fullName}</div></div>
                      <div className="row"><p>Ratings</p><div className='fw600 ratingsDiv'>
                        <FaStar className='starIconFilled' style={{ color: "var(--primaryColor)" }} />
                        <span>{`${selectedParticipant.sellerId.rating.toFixed(1)} (${selectedParticipant.sellerId.noOfReviews})`}</span>
                      </div></div></>}
                    <div className="row"><p>From</p><div className='fw600'>{selectedParticipant.role === "seller" ? selectedParticipant.sellerId.sellerAddress.country.name : selectedParticipant.buyerAddress.country.name}</div></div>
                    <div className="row"><p>Role</p><div className='fw600'>{selectedParticipant.role}</div></div>
                    <div className="row"><p>Member Since</p><div className='fw600'>
                      {formatDate(selectedParticipant?.role === "seller" ? selectedParticipant?.sellerId?.createdAt : selectedParticipant?.createdAt)}
                    </div></div>
                  </>}
                  {isOtherInfoLoading && <Loader type="simple" />}
                  {!isOtherInfoLoading && (
                    <>
                      {activeOrders.length > 0 && (
                        <div className="chatOtherInfoSection">
                          <h3 className="chatOtherInfoSectionTitle"><Package size={16} /> Active Order{activeOrders.length > 1 ? 's' : ''}</h3>
                          {activeOrders.map((order) => (
                            <Link key={order._id} to={user?.role === 'seller' ? `/sellerOrderDetailPage/${order._id}` : `/orderDetailPage/${order._id}`} className="chatActiveOrderCard">
                              <div className="chatActiveOrderCardTop">
                                <span className="chatActiveOrderId">{order.customOrderId}</span>
                                <span className="chatActiveOrderStatus">{order.timelineStatus}</span>
                              </div>
                              <p className="chatActiveOrderTitle">{order.productInfo?.title}</p>
                              <span className="chatActiveOrderTotal">{formatCurrency(user?.role === 'seller' ? calculateSellerAmount((order.summary?.subtotal || 0) + (order.summary?.deliveryFee || 0), orderSellerFeePercent(order, feesObj?.seller)) : (order.summary?.total || 0), currency, exchangeRate)}</span>
                            </Link>
                          ))}
                        </div>
                      )}
                      {orderHistory.length > 0 && (user?.role === 'seller' || selectedParticipant.role === 'seller') && (
                        <div className="chatOtherInfoSection">
                          <h3 className="chatOtherInfoSectionTitle">Order History</h3>
                          {orderHistory.slice(0, 4).map((order) => (
                            <Link key={order._id} to={user?.role === 'seller' ? `/sellerOrderDetailPage/${order._id}` : `/orderDetailPage/${order._id}`} className="chatOrderHistoryItem">
                              <span>{order.customOrderId}</span>
                              <span>{order.timelineStatus}</span>
                            </Link>
                          ))}
                          {orderHistory.length > 4 && <span className="chatOrderHistoryMore">{orderHistory.length - 4} more</span>}
                        </div>
                      )}
                      {sellerProducts.length > 0 && selectedParticipant.role === 'seller' && (
                        <div className="chatOtherInfoSection chatOtherPostingsSection">
                          <h3 className="chatOtherInfoSectionTitle"><ShoppingBag size={16} /> Other Postings</h3>
                          <div className="chatOtherPostingsGrid">
                            {sellerProducts.slice(0, 6).map((product) => (
                              <Link key={product.id} to={`/productDetail/${product.id}`} className="chatOtherPostingCard">
                                <img src={product.images?.[0] || SellerDefault} alt={product.title} />
                                <div className="chatOtherPostingCardInfo">
                                  <p className="chatOtherPostingTitle">{product.title}</p>
                                  <span className="chatOtherPostingPrice">{formatCurrency(product.price, currency, exchangeRate)}</span>
                                </div>
                              </Link>
                            ))}
                          </div>
                          {sellerProducts.length > 6 && <Link to={`/vendorDetail/${selectedParticipant.sellerId?._id}`} className="chatOtherPostingsLink">View all</Link>}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </>
            ) : (
              <div className='nothingFound'>
                <FaUsersSlash className='icon' />
              </div>
            )}
          </div>
        </div>
      </section>

      {showImageModel &&
        <div className="modalOverlay previewImageModal">
          <div className="modalContent">
            <div className="modalHeader">
              <h3>Preview Image</h3>
              <button onClick={() => setShowImageModel(null)} className="closeButton">×</button>
            </div>
            <div className="form">
              <div className="imgDiv previewImgDiv">
                <img src={`${showImageModel}`} alt="Preview" />
              </div>
            </div>
            <div className="modalActions">
              <button type="button" onClick={() => setShowImageModel(null)} className="primaryBtn3">Cancel</button>
            </div>
          </div>
        </div>
      }

      {showQuoteModel &&
        <QuoteModal
          isOpen={showQuoteModel}
          onClose={() => { setShowQuoteModel(false); setEditingOffer(null); setEditingOfferId(null); }}
          onSubmit={handleSendOffer}
          products={quoteItems}
          feesObj={feesObj}
          currency={currency}
          exchangeRate={exchangeRate}
          isSeller={user?.role === 'seller'}
          initialOffer={editingOffer}
          editingOfferId={editingOfferId}
        />
      }

      {isCheckmateLoading && <Loader type="checkmate" />}
    </div>
  );
};

export default ChatPage;